import React from "react";
import path from "../Images/josue.jpg";
import { BsFillPersonFill } from "react-icons/bs";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function About() {
  const { elementRef, isVisible } = useRevealOnScroll();
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section
      ref={elementRef}
      className={`about-container relative content-center flex flex-col overflow-hidden bg-main-bg-dark/40 px-6 py-20 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
      id="about"
    >
      <div className="icon-container flex justify-center pb-3 text-4xl">
        <BsFillPersonFill className="text-coding-color" />
      </div>
      <h1 className="font-title text-center text-3xl font-bold text-header-color">
        {t.about.title}
      </h1>
      <div className="content-container mx-auto mt-12 flex max-w-5xl flex-col items-center gap-12 md:flex-row md:items-start md:justify-between">
        <div className="content md:text-xl text-white md:w-3/5">
          <p className="leading-relaxed">
            {t.about.paragraph1}
          </p>
          <p className="mt-4 leading-relaxed">
            {t.about.paragraph2}
          </p>
        </div>
        <div className="personal-image flex justify-center md:w-2/5">
          <img
            src={path}
            alt="Portrait of Josue Rushanika"
            width={564}
            height={627}
            className="w-3/4 rounded-full shadow-lg md:w-full"
          />
        </div>
      </div>
    </section>
  );
}

export default About;
